






















import Vue from 'vue';

interface Props {
  sources: Array<any>;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  props: {
    sources: {
      type: Array,
      required: true,
    },
  },
});
